<template>
  <div>
    <b-card title="Stok Kartı Güncelle">
      <validation-observer ref="simpleRules">
        <stock-form />
      </validation-observer>
    </b-card>
    <div class="text-left">
      <b-button
        variant="primary"
        class="text-left"
        :disabled="dataItem.submitStatus"
        @click="submitData"
      >
        Kaydet
      </b-button>
    </div>
  </div>
</template>
<script>
import { BCard, BButton } from 'bootstrap-vue'
import StockForm from '@/views/Admin/Stocks/Components/stockForm.vue'
import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'EditStocks',
  components: {
    StockForm,
    BCard,
    BButton,
    ValidationObserver,
  },
  computed: {
    dataItem() {
      return this.$store.getters['stocks/dataItem']
    },
    saveData() {
      return this.$store.getters['stocks/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.dataItem.submitStatus = false
        this.$router.push({ name: 'Stocks' })
        this.dataItem.submitStatus = false
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('stocks/getDataItem', this.$route.params.id)
    },
    submitData() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.dataItem.submitStatus = true
          this.$store.dispatch('stocks/saveData', this.dataItem)
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
